import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { StateManagementService } from 'src/app/requests-detail-view/state-managemnet.service';
import { RouterPathConfig } from '../constants/router-path.config';
import { USER_ROLE } from '../constants/user-role.enum';
import { VIEW_TYPE } from '../constants/view-type.enum';
import { ViewDetails } from '../models/view-details.model';
import { LoggedInUserService } from './logged-in-user.service';
import { SidebarMenuService } from './sidebar-menu.service';

@Injectable({
    providedIn: 'root'
})
export class RoutingHandlerService {
    userRole: USER_ROLE;
    viewDetails: ViewDetails;
    onRouterChangeSetActiveHeaderMenu = new Subject<any>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private loggedInUserService: LoggedInUserService,
        private sidebarMenuService: SidebarMenuService,
        private stateManagementService: StateManagementService
    ) {}

    getUserPathFromRole(userRole: string) {
        if (userRole === USER_ROLE.ADMIN || this.loggedInUserService.isSuperAdmin()||this.loggedInUserService.isGeneralManager()) {
            return RouterPathConfig.USER_PATH.ADMIN;
        } else if (userRole === USER_ROLE.SHIFT_MANAGER || userRole === USER_ROLE.SECTION_MANAGER || userRole === USER_ROLE.OPERATION_SHIFT_MANAGER) {
            return RouterPathConfig.USER_PATH.MANAGER;
        } else if (userRole === USER_ROLE.EMPLOYEE || userRole === USER_ROLE.OPERATION_EMPLOYEE) {
            return RouterPathConfig.USER_PATH.EMPLOYEE;
        } else if (userRole === USER_ROLE.REQUESTER) {
            return RouterPathConfig.USER_PATH.REQUESTER;
        } else if (userRole === USER_ROLE.ACCOUNT_MANAGER) {
            return RouterPathConfig.USER_PATH.ACCOUNT_MANAGER;
        } else {
            return undefined;
        }
    }

    validatePath(sideMenuList: ViewDetails[], secondaryPath: string) {
        const index = sideMenuList.findIndex(v => v.path === secondaryPath);
        const isValid = index !== -1 ? true : false;
        return {
            isValid: isValid,
            index: index
        };
    }

    getUserAndRequestPath(userRole: USER_ROLE, viewDetails: ViewDetails) {
        // return path as e.g admin/new-requests
        const userPath = this.getUserPathFromRole(userRole);
        const requestPath = viewDetails.path;
        return userPath + '/' + requestPath;
    }

    navigateBackToList(userRole: USER_ROLE, viewDetails: ViewDetails) {
        let userRequestPath = this.getUserAndRequestPath(userRole, viewDetails);

        if (viewDetails.viewType === VIEW_TYPE.DASHBOARD) {
            if (this.router.url.includes('/request/')) {
                const indexOff = this.router.url.indexOf('/request/');
                userRequestPath = this.router.url.slice(0, indexOff);
            } else {
                const lastIndex = this.router.url.lastIndexOf('/');
                userRequestPath = this.router.url.slice(0, lastIndex);
            }
        } else if (viewDetails.viewType === VIEW_TYPE.CLIENTS) {
            userRequestPath = RouterPathConfig.DATA_MANAGEMENT + '/' + viewDetails.path;
        }

        // Get the stored query parameters
        const currentQueryParams = this.route.snapshot.queryParams;

        // Navigate with preserved query parameters
        this.router.navigate([userRequestPath], {
            queryParams: currentQueryParams,
            queryParamsHandling: 'preserve' 
        });
    }
    

    navigateToNewRequestForm(userRole, viewDetails) {
        const userRequestPath = this.getUserAndRequestPath(userRole, viewDetails);
        this.router.navigate([userRequestPath, RouterPathConfig.CREATE_REQUEST_PATH], { relativeTo: this.route });
    }

    isUserOnListingPage(userRole) {
        const userPath = this.getUserPathFromRole(userRole);
        const urlWithOutParams = this.location.path().split('?')[0];
        const urlAfterUserPath = urlWithOutParams.split(userPath).pop();
        const segmentCount = urlAfterUserPath.split('/').length - 1;

        return segmentCount === 1 ? true : false;
    }

    navigateToDashboardClientEmployeeOperationList(userRole, viewDetails, path) {
        const userRequestPath = this.getUserAndRequestPath(userRole, viewDetails);
        this.router.navigate([userRequestPath, path], { relativeTo: this.route });
    }

    navigateToDashboardClientEmployeeOperationDetail(path, id) {
        this.getUserRoleAndViewDetails();
        const userRequestPath = this.getUserAndRequestPath(this.userRole, this.viewDetails);
        this.router.navigate([userRequestPath, path, id], {
            relativeTo: this.route
        });
    }

    navigateToRequestDetailsView(requestId, viewObject: ViewDetails, route) {
        const currentQueryParams = this.route.snapshot.queryParams;
    
        console.log("currentQueryParams (Routing to Details)", currentQueryParams);

     if (viewObject.viewType === VIEW_TYPE.DASHBOARD) {
         this.router.navigate(['request', requestId], {
             relativeTo: route,
             queryParams: currentQueryParams,
             queryParamsHandling: 'preserve'
         });
     } else {
         this.router.navigate([viewObject.path, 'request', requestId], {
             relativeTo: route,
             queryParams: currentQueryParams,
             queryParamsHandling: 'preserve'
         });
     }
    }
    

    getUserRoleAndViewDetails() {
        this.userRole = this.loggedInUserService.getUserRole();
        this.viewDetails = this.sidebarMenuService.getViewObject();
    }

    // navigateTo(path) {
    //     if (!path) {
    //         console.warn('Attempted to navigate to a null/undefined path');
    //         return;
    //     }
    //      // Rest of your existing navigation logic
    // this.router.navigateByUrl(path);
    //     // this.router.navigate([path], { relativeTo: this.route });
    // }
    navigateTo(path, options: { clearState?: boolean } = {}) {
        if (!path) {
            console.warn('Attempted to navigate to a null/undefined path');
            return;
        }
        
        // Check if this is a call record navigation
        const isCallRecord = path.includes('/callRecord');
    
        
        // Use router.navigateByUrl for a clean navigation
        this.router.navigateByUrl(path, { 
            replaceUrl: isCallRecord // Use replaceUrl for call records to ensure clean URL
        });
    }
    
    // Special method for navigating to call record pages
    navigateToCallRecord(path) {
        if (!path) {
            console.warn('Attempted to navigate to a null/undefined path');
            return;
        }
        
        // // Disable state tracking during this navigation
        // this.stateManagementService.disableStateTracking();
        
        // Force clear state
        // this.stateManagementService.clearState(true);
        
        // Use a complete navigation that replaces the URL to ensure clean history
        this.router.navigateByUrl(path, { 
            replaceUrl: true
        });
    }
}
